import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { Box, Typography, CircularProgress, List, ListItem, ListItemText, ListItemIcon, Paper } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import ListIcon from '@mui/icons-material/List';

const ShowAllForms = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/forms/all`);
        setForms(response.data);
        console.log(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load forms');
        setLoading(false);
        enqueueSnackbar('Failed to retrieve forms', { variant: 'error' });
      }
    };
    fetchForms();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box width="54%" mx={0} p={3}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center" color="text.primary">
          All Forms
        </Typography>
        {forms.length === 0 ? (
          <Typography variant="body1" color="text.secondary" align="center">
            No forms available.
          </Typography>
        ) : (
          <List>
            {forms.map((form) => (
              <ListItem key={form._id} alignItems="flex-start" sx={{ mb: 2 }}>
                <ListItemIcon>
                  <DescriptionIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" color="text.primary">
                      <Link to={`/admin/forms/${form._id}`} style={{ color: '#1976d2', textDecoration: 'none' }}>
                        {form.title}
                      </Link>
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography variant="subtitle1" color="text.primary" sx={{ pl: 0 }}>
                        Workflow Name: {form.workflow.title}
                      </Typography>

                      <Typography variant="subtitle2" color="text.primary" sx={{ pl: 0 }}>
                        Fields:
                      </Typography>
                      <List component="div" disablePadding>
                        {form.fields.map((field, index) => (
                          <ListItem key={index} sx={{ pl: 0 }}>
                            <ListItemIcon>
                              <ListIcon sx={{ color: 'text.primary' }} />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography color="text.primary">
                                  <strong>{field.fieldName}:</strong> {field.fieldType}
                                </Typography>
                              }
                              secondary={
                                (field.fieldType === 'checkbox' || field.fieldType === 'radio') && field.options.length > 0 && (
                                  <List component="div" disablePadding>
                                    {field.options.map((option, i) => (
                                      <ListItem key={i}>
                                        <ListItemText
                                          primary={<Typography color="text.primary">- {option.label}</Typography>}
                                          secondary={
                                            field.fieldType === 'checkbox'
                                              ? `Checked: ${option.checked ? 'Yes' : 'No'}`
                                              : 'Radio Option'
                                          }
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                )
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Box>
  );
};

export default ShowAllForms;
